module.exports = __webpack_public_path__ + "img/14.3dc6c474.jpg";